import { useState } from 'react';

const useFormSubmit = (sheetUrl) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const submitForm = async (formData) => {
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Remove the unused 'response' variable
      await fetch(sheetUrl, {
        method: 'POST',
        mode: 'no-cors', // This is important for Google Sheets
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      // With no-cors, we assume it worked
      setSubmitStatus('success');
      
      // Auto-hide success message after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);
      
    } catch (error) {
      console.error('Submission error:', error);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(null), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return { submitForm, isSubmitting, submitStatus };
};

export default useFormSubmit;